





































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditArticle from "./edit-article.vue";
import Ajax from "@/lib/ajax";

class PageArticleRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  classTypeId: number = 1;
  multiTypeName: string = "文章";
  parentId?: number;
  parentName: string = "上级分类";
  categoryId?: number;
  isAudit: boolean = true;
  screenWidth: number = document.body.clientWidth;
}

@Component({
  components: { EditArticle },
})
export default class Articles extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageArticleRequest = new PageArticleRequest();
  editModalShow: boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];

  //多级菜单选择关闭时操作
  visibleChange(isShow) {
    // if (!isShow) this.getpage()
  }
  searchGetpage() {
    this.$store.state.article.currentPage = 1;
    this.getpage();
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.searchGetpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.article.list;
  }
  get loading() {
    return this.$store.state.article.loading;
  }
  create() {
    this.editModalShow = true;
    this.$store.state.article.editArticle.classTypeId = this.pagerequest.classTypeId;
    this.$store.state.article.editArticle.multiTypeName = this.pagerequest.multiTypeName;
    this.$store.state.article.editArticle.parentId = this.pagerequest.parentId;
    this.$store.state.article.editArticle.parentName = this.pagerequest.parentName;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("article/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("article/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store
      .dispatch({
        type: "article/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId }, //文章新闻
      })
      .then(async (result) => {
        this.data = this.$store.state.article.cascaders.items;
        await this.$store
          .dispatch({
            type: "article/getTopicCascader", //专题
            data: { classTypeId: 6 },
          })
          .then(async (result) => {
            this.getpage();
          });
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "article/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.article.pageSize;
  }
  get totalCount() {
    return this.$store.state.article.totalCount;
  }
  get currentPage() {
    return this.$store.state.article.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  turnClent(param) {
    Ajax.post("http://www.sxjy.cq.cn/detail/", param);
  }
  columns = [
    {
      title: "分类",
      width: 130,
      key: "categoryName",
    },
    {
      title: "标题",
      key: "title",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.title,
                href:
                  "http://www.sxjy.cq.cn/detail/" +
                  params.row.id +
                  "?cid=" +
                  params.row.categoryList[0],
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.title,
          ),
        ]);
      },
    },
    {
      title: "点击",
      width: 65,
      key: "clickVolume",
    },
    {
      title: "推荐",
      width: 65,
      render: (h: any, params: any) => {
        return h("span", params.row.isRecommend ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "审核",
      width: 65,
      render: (h: any, params: any) => {
        return h("span", params.row.isAudit ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "序号",
      width: 65,
      key: "sortNo",
    },
    {
      title: "范围",
      width: 65,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color:
                params.row.externalType > 0
                  ? params.row.externalType == 1
                    ? ""
                    : "red"
                  : "#2d8cf0",
            },
          },
          params.row.externalType > 0
            ? params.row.externalType == 1
              ? "对外"
              : "对内"
            : "内外",
        );
      },
    },
    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/" + params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName,
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString(),
        );
      },
    },

    {
      title: this.L("Actions"),
      key: "Actions",
      width: 140,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId,
                  );

                  this.$store.commit("article/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.article.editArticle.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit"),
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" +
                        (params.index + 1) +
                        "】条记录吗？",
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "article/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete"),
          ),
        ]);
      },
    },
  ];
  columns2 = [
    {
      title: "标题",
      key: "title",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.title,
                href:
                  "http://www.sxjy.cq.cn/detail/" +
                  params.row.categoryList[0] +
                  "/" +
                  params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.title,
          ),
        ]);
      },
    },
    {
      title: "点击",
      width: 65,
      key: "clickVolume",
    },
    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/inhome/" +
                  params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName,
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString(),
        );
      },
    },

    {
      title: this.L("Actions"),
      key: "Actions",
      width: 140,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId,
                  );
                  this.$store.commit("article/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.article.editArticle.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit"),
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" +
                        (params.index + 1) +
                        "】条记录吗？",
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "article/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete"),
          ),
        ]);
      },
    },
  ];
  async created() {
    this.$store.state.article.currentPage = 1;
    this.loadCascaders();
  }
}
